import {
  GetMissingFieldsLevelParameter,
  ListIncomingPayerPayeeLinkRequests200ResponseDataInner as IncomingLinkRequest
} from "@wingspanhq/wingspan-api-sdk";
import { onboardingApi } from "@api";
import { queriesOnboarding } from "@query";
import {
  PATH_ONBOARDING,
  PATH_ONBOARDING_PAYEE
} from "../../../modules/Onboarding/paths";
import { selectorIsVerificationStarted } from "../../../shared/selectors/selectorIsVerificationStarted";

// Link requests only ever run payer→payee, so an incoming one means this person
// was invited as a contractor — the v3 stand-in for v1's payee `user.contexts`.
export const getOnboardingRedirectPath = async (params: {
  incomingLinkRequests: IncomingLinkRequest[];
  pathname: string;
}): Promise<string | undefined> => {
  if (params.pathname.startsWith(PATH_ONBOARDING)) {
    return undefined;
  }

  if (params.incomingLinkRequests.length === 0) {
    return undefined;
  }

  try {
    const onboardingStatus = await onboardingApi.getOnboardingStatus({});

    queriesOnboarding.getOnboardingStatus.setQueryData(
      undefined,
      onboardingStatus
    );

    const isStarted = selectorIsVerificationStarted({
      level: GetMissingFieldsLevelParameter.TAX,
      verifications: onboardingStatus.verifications
    });

    return isStarted ? undefined : PATH_ONBOARDING_PAYEE;
  } catch (error) {
    // A status read that fails must never lock anybody out of the app.
    console.error("Failed to read onboarding status at init:", error);
    return undefined;
  }
};
